import React from 'react';
import SidebarItem from './SidebarItem'; // Adjust the import path as needed
import { FaUser, FaUsers, FaBox, FaFileUpload, FaMedal, FaNewspaper } from 'react-icons/fa';

interface MenuItem {
  to: string;
  icon: React.ReactElement;
  label: string;
}

const menuItems: MenuItem[] = [
  {
    to: '/',
    icon: <FaUser />,
    label: '프로필',
  },
  {
    to: '/manager/page',
    icon: <FaUsers />,
    label: '고객 관리',
  },
  {
    to: '/manager/Product',
    icon: <FaBox />,
    label: '업로드 상품',
  },
  {
    to: '/manager/event',
    icon: <FaFileUpload />,
    label: '이벤트',
  },
  // {
  //   to: '/manager/fileuploadform',
  //   icon: <FaFileUpload />,
  //   label: '업로드 파일',
  // },
  {
    to: '/manager/Emblem',
    icon: <FaMedal />,
    label: '엠블럼 등록',
  },
  {
    to: '/manager/Article',
    icon: <FaNewspaper />,
    label: '기사 등록',
  },
];

const ManagerSidebar: React.FC = () => {
  return (
      <section className="w-64 bg-black/70 text-white">
        <ul className="p-4 h-full font-semibold tracking-wide">
          {menuItems.map((item) => (
              <SidebarItem
                  key={item.to} // Uses 'to' as a unique key
                  to={item.to}
                  icon={item.icon}
                  label={item.label}
              />
          ))}
        </ul>
      </section>
  );
};

export default ManagerSidebar;